<template>
  <div id="top">
  <div class="bannerBox">
  <div class="swiper-container" id="swiper1">
    <div class="swiper-wrapper swiper-no-swiping" >
      <div class="swiper-slide">
        <img src="./img/bg-1.jpg">
      </div>
      <div class="swiper-slide">
        <img src="./img/bg-2.jpg">
      </div>
      <div class="swiper-slide">
        <img src="./img/bg-3.jpg">
      </div>
      <div class="swiper-slide">
        <img src="./img/bg-4.jpg">
      </div>
    </div>
  </div>

  <div class="swiper-container" id="swiper2">
    <div class="swiper-wrapper swiper-no-swiping">
      <div class="row swiper-slide">
        <div class="col-md-6 col-xs-6 col-sm-6 slide-text wow dadeInDown" data-wow-delay="0.8s">
          <div>
          <h1>{{$t("slide.title1")}}</h1>
          <p> {{$t("slide.text1")}}</p>
          <router-link to="/about" class="smoothScroll">
            <button id="btn" type="button" class="button" @click="turn">{{$t("slide.read_more")}}</button>
          </router-link>
        </div>
        </div>
        <div class=" img-container col-md-6 col-xs-6 col-sm-6">
          <img class="img2" src="./img/short1.png">
        </div>
      </div>
      <div class="row swiper-slide">
        <div class="col-md-6 col-xs-6 col-sm-6 slide-text wow dadeInDown" data-wow-delay="0.8s">
          <div>
          <h1>{{$t("slide.title2")}}</h1>
          <p>{{$t("slide.text2")}}</p>
          <router-link to="/about" class="smoothScroll">
            <button  type="button" class="button" @click="turn">{{$t("slide.read_more")}}</button>
          </router-link>
        </div>
        </div>
        <div class="img-container col-md-6 col-xs-6 col-sm-6">
          <img src="./img/short2.png">
        </div>
      </div>
      <div class="row swiper-slide">
        <div class="col-md-6 col-xs-6 col-sm-6 slide-text wow dadeInDown" data-wow-delay="0.8s">
          <div>
          <h1>{{$t("slide.title3")}}</h1>
          <p>{{$t("slide.text3")}}</p>
          <router-link to="/about" class="smoothScroll">
            <button type="button" class="button" @click="turn">{{$t("slide.read_more")}}</button>
          </router-link>
        </div>
        </div>
        <div class="img-container col-md-6 col-xs-6 col-sm-6">
          <img class="img3" src="./img/short3.png">
        </div>
      </div>
      <div class="row swiper-slide">
        <div class="col-md-6 col-xs-6 col-sm-6 slide-text wow dadeInDown" data-wow-delay="0.8s">
          <div>
          <h1>{{$t("slide.title4")}}</h1>
          <p>{{$t("slide.text4")}}</p>
          <router-link to="/about" class="smoothScroll">
            <button type="button" class="button" @click="turn">{{$t("slide.read_more")}}</button>
          </router-link>
        </div>
        </div>
        <div class="img-container col-md-6 col-xs-6 col-sm-6">
          <img class="img3" src="./img/short3.png">
        </div>
      </div>
    </div>
  </div>
  <div class="left"><img src="./img/bannerL.png"></div>
  <div class="right"><img src="./img/bannerR.png"></div>    
</div>
</div>
</template>
<script>
  export default {
    mounted: function () {
      //最里层轮播
      var mySwiper1 = new Swiper('#swiper1',{
          loop: true,
          autoplay : 8000,
          speed : 1000,
          autoplayDisableOnInteraction : false
        });

      //上层轮播
      var mySwiper2 = new Swiper('#swiper2',{
          loop: true,
          autoplay : 2500,
          // effect : 'coverflow',
          speed : 5000,
          // slidesOffsetBefore : 600,
          autoplayDisableOnInteraction : false
        });
      //前进后退按钮
      $(".left").click(function(){
        mySwiper1.slidePrev();
        mySwiper2.slidePrev();
      })
      $(".right").click(function(){
        mySwiper1.slideNext();
        mySwiper2.slideNext();
      }) 
      },
      methods:{
        turn:function(){
          location.href = "#about";
        }
    }
  }
</script>
<style>
#top {
  padding-top: 70px;
  margin-top: -70px;
}
.bannerBox{
  width: 100%;
  height:650px;
  position: relative;
  /*top: 8px;*/
  margin: auto 0px;
 /* border: solid 1px red;*/
}
.bannerBox h1{
  font-size: 40px;

}
.bannerBox:hover .left{
  display: block;
}
.bannerBox:hover .right{
  display: block;
}
#swiper1{
  width: 100%;
  height: 100%;      
}
#swiper2 {
  width: 100%;
  height: 70%;
}
#swiper1{
  filter:alpha(opacity=95);   
  -moz-opacity:0.95;     
  opacity: 0.95;
  object-fit: cover;         
}
#swiper2{
  position: absolute;
  left: 0;top: 20%;
}
#swiper2 .col-md-6{
  height: 100%;
}
#swiper2 .row{
  margin: 0;
  padding: 0;
}
#swiper1 .swiper-slide,#swiper1 img{
  width: 100%;
  font-size: 100px;
  line-height:280px;
  text-align: center;
  object-fit: cover;
  object-position: center;
  background-size: cover;
}
.img-container {
  display:flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.slide-text  {
  height: 100%;
  display:flex;
  justify-content: center;
  align-items: center;
  text-align:center;
}
.slide-text h1 {
  color: #fff;
  text-align: center;
  /*font-weight: bold;*/
}
.slide-text p {
  font-size: 25px;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}
.slide-text .button {
  width: 150px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  outline: none;
  background-color: #4b8095;
  color: #fff;
  border: none;
  border-radius: 5px;
}
.slide-text .button:hover {
  background-color: #d26581;
}
#swiper2 img {
 background-size: cover;
 height: 100%;
 width: auto;
}
#swiper2 .swiper-slide{
  overflow: hidden;
}
.direction img{
  margin-top: 12px;
}
.left{
  position: absolute;
  top: 45%;
  width: 26px;
  height: 65px;
  background-color: rgba(64,64,64,0.6);
  text-align: center;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  z-index: 12;
  display: none;
}
.left img{
  width:15px ;
  height: 28px;
  margin-top: 18px;
  margin-right: 6px;        
}
.right{
  position: absolute;
  top:45%;
  right: 0;
  width: 26px;
  height: 65px;
  background-color: rgba(64,64,64,0.6);
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  z-index: 2; 
  display: none;      
}
.right img{
  width:15px ;
  height: 28px;
  margin-top: 18px;
  margin-left: 6px;       
}
/*css3动画*/
#swiper2 img{
  transition: all .4s;
}
#swiper2 img:hover{
  -ms-transform:scale(0.9); /* IE 9 */
  -webkit-transform: scale(0.9); /* Safari */
  transform: scale(0.9); /* 标准语法 */
}
@media only screen and (max-width: 768px) {
  .bannerBox {
    height: 300px;
  }
  #swiper1 img {
    height: 300px;
  }
  #swiper2 {
  width: 100%;
  height: 65%;
}
#swiper2{
  position: absolute;
  left: 0;top: 20%;
}
.slide-text h1 {
  font-size: 15px;
  letter-spacing: 1px;
  margin: 0;
}
.slide-text p {
  font-size: 10px;
  line-height: 1.5;
   letter-spacing: 1px;
   white-space: nowrap;
   white-space: normal;
/*  font-weight: bold;*/
}
.slide-text .button {
  width: 80px;
  height: 30px;
  line-height: 30px;
  font-size: 10px;
}
#swiper2 img{
    max-width: 100px;
    max-height: 100%;
  }
#swiper2 .img3{
  max-width: 90%;
  max-height: 60%;
}
#swiper2 .img2{
  max-width: 150px;
  max-height: 300px;
}
.right{
  top:35%;
}
.left{
  top: 35%;
}
}
@media only screen and (min-width: 763px) and (max-width: 1024px) {
  .bannerBox {
    height:550px;
  }
  #swiper1 img {
    height: 550px;
  }
  #swiper2 {
    width: 100%;
    height: 75%;
}
#swiper2{
  position: absolute;
  left: 0;top: 15%;
}
.slide-text h1 {
  font-size: 25px;
  letter-spacing: 35px;
}
.slide-text p {
  font-size: 16px;
  line-height: 35px;
  font-weight: bold;
}
.slide-text .button {
  width: 120px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
#swiper2 img{
    max-width: 200px;
    max-height: 80%;
  }
#swiper2 .img3{
  max-width: 350px;
  max-height: 250px;
}
#swiper2 .img2{
  max-width: 300px;
  max-height: 400px;
}
}
</style>


// WEBPACK FOOTER //
// src/components/slide1.vue